"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidityMath = void 0;
const math_1 = require("@sushiswap/math");
const internalConstants_1 = require("../internalConstants");
class LiquidityMath {
    /**
     * Cannot be constructed.
     */
    constructor() { }
    static addDelta(x, y) {
        if (math_1.JSBI.lessThan(y, internalConstants_1.ZERO)) {
            return math_1.JSBI.subtract(x, math_1.JSBI.multiply(y, internalConstants_1.NEGATIVE_ONE));
        }
        else {
            return math_1.JSBI.add(x, y);
        }
    }
}
exports.LiquidityMath = LiquidityMath;
//# sourceMappingURL=liquidityMath.js.map